import React from 'react'
import './Cargo.css'

function Cargo() {
  return (
      <div className="cargo-services-container">
      {/* Hero section with image and overlay text */}
      <div className="cargo-services-hero">
        <div className="cargo-services-overlay">
          <h1>Cargo</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
       {/* Content section with image and text */}
      <div className="cargo-content">
        <div className="cargo-image">
          <img src="/Pics/cargo.jpg" alt="Full Logistics Services" />
        </div>
        
        <p>
        Centrex marine services boasts one of the largest project cargo teams in the freight forwarding industry, equipped with extensive knowledge in handling diverse cargo types such as breakbulk, heavy, oversized, and abnormal shipments. While many project and freight forwarders typically rely on convenonal and breakbulk cargo vessels and carriers for project cargo, we differenate ourselves.
        </p>
        
        <p>
      Centrex marine services serves as the vital bridge connecng cargo stakeholders and shipping firms. This unique posion enables the team to extend our services to clients including charterers and owners alike, assisng all in managing cargo movement, available posions, and even commercial operaons.
        </p>
        
        <p>
        We frequently secure space for breakbulk cargo on container vessels thanks to our strong connecons with stevedoring partners and liner contacts. This approach effecvely reduces costs, enhances transit mes, improves reliability, and provides greater flexibility. These aspects of our breakbulk cargo service set us apart from others in the industry.
        </p>
    
      </div>
      </div>
  )
}

export default Cargo